import { Mutation } from "@apollo/client/react/components";
import * as palette from "@govlaunch/palette";
import React from "react";
import { FormattedMessage } from "react-intl";
import Switch from "react-switch";
import { useToggle } from "react-use";
import ToggleUsersCanRequestContentTranslation from "~/lib/mutations/ToggleUsersCanRequestContentTranslation";
import { IToggleUsersCanRequestContentTranslationMutation } from "~/lib/mutations/__generated__/ToggleUsersCanRequestContentTranslation.generated";
import { IMutationToggleUsersCanRequestContentTranslationArgs } from "~/types/types";

interface UsersCanRequestContentTranslationRowProps {
  suggestMyContentTranslation: boolean;
  vendorId: string;
}

interface UsersCanRequestContentTranslationMutationProps {
  suggestMyContentTranslation: boolean;
  vendorId: string;
}

export function UsersCanRequestContentTranslationRow({
  suggestMyContentTranslation,
  vendorId,
}: UsersCanRequestContentTranslationRowProps) {
  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
          maxWidth: 200,
        }}
      >
        <FormattedMessage defaultMessage="Enable Translation of Vendor’s Profile Page" id="ysk4G7" />
      </div>

      <div
        css={{
          display: "grid",
          gridColumnGap: 12,
          gridTemplateColumns: "repeat(2, max-content)",
          alignItems: "center",
          color: palette.text,
          fontSize: 16,
          "& > strong": {
            fontWeight: 600,
          },
        }}
      >
        <ToggleUsersCanRequestContentTranslationMutation
          suggestMyContentTranslation={suggestMyContentTranslation}
          vendorId={vendorId}
        />
      </div>
    </>
  );
}

const ToggleUsersCanRequestContentTranslationMutation = ({
  suggestMyContentTranslation,
  vendorId,
}: UsersCanRequestContentTranslationMutationProps) => {
  const [usersCanRequestTranslation, toggleUsersCanRequestTranslation] = useToggle(suggestMyContentTranslation);

  return (
    <Mutation<IToggleUsersCanRequestContentTranslationMutation, IMutationToggleUsersCanRequestContentTranslationArgs>
      onCompleted={() => {}}
      variables={{
        vendorId: vendorId,
        requestContentTranslationAllowed: usersCanRequestTranslation,
      }}
      mutation={ToggleUsersCanRequestContentTranslation}
    >
      {(toggleAccessToTranslation) => (
        <Switch
          uncheckedIcon={
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 15,
                color: palette.darkGray,
                paddingRight: 10,
              }}
            >
              off
            </div>
          }
          checkedIcon={
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: 15,
                color: "#fff",
                paddingLeft: 10,
              }}
            >
              on
            </div>
          }
          handleDiameter={22}
          height={26}
          width={65}
          onChange={async (checked) => {
            toggleUsersCanRequestTranslation(checked);
            await toggleAccessToTranslation({
              variables: {
                vendorId: vendorId,
                requestContentTranslationAllowed: checked,
              },
            });
          }}
          checked={usersCanRequestTranslation}
          onColor={palette.greenSuccess}
          offColor={palette.lightGray}
        />
      )}
    </Mutation>
  );
};
